import { useState } from 'react';

import { Button, Popover } from '@mui/material';
import { BlockPicker, type ColorResult } from 'react-color';
import { Checkboard } from 'react-color/lib/components/common';

export type ColorPickerButtonProps = {
    allColors: string[];
    currentColor: string;
    onChange: (color: ColorResult) => void;
};

export default function ColorPickerButton(props: ColorPickerButtonProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleComplete = (color: any) => {
        if ((color.hex as string).length === 7) {
            handleClose();
        }
    };

    return (
        <>
            <Button
                style={{ backgroundColor: props.currentColor, borderColor: '#666' }}
                aria-describedby={id}
                variant={props.currentColor === 'transparent' ? 'outlined' : 'contained'} // Add outline for transparent checkboard.
                onClick={handleClick} sx={{ minWidth: '1.5rem' }}
                fullWidth
            >
                &nbsp;
                {props.currentColor === 'transparent' &&
                    <Checkboard/>
                }
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <BlockPicker
                    colors={props.allColors}
                    color={props.currentColor}
                    onChange={(color) => props.onChange(color)}
                    onChangeComplete={handleComplete}
                />
            </Popover>
        </>
    );
}
